import {coordinator, routes} from "@/plugins/axios";

export function useChangeOrganizationTitleColor() {
    async function changeOrganizationTitleColor(orgSlug, color){
        return coordinator.patch(routes.organizations.update(orgSlug), {banner_text_color: color})
            .then(response => {
                return Promise.resolve(response.data);
            })
            .catch(err => {
                return Promise.reject(err);
            });
    }

    return {
        changeOrganizationTitleColor,
    }
}